import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import { compose } from 'shared/helpers';
import {
  setNavbarVisibility,
  setFooterVisibility,
} from 'shared/actions/view/web';

import {mixClasses as cx} from 'helpers';
import { MgTextLogoBouncer } from 'components/elems';


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setNavbarVisibility,
    setFooterVisibility,
  }, dispatch);
}


class InitialLoading extends React.Component {
  componentWillMount() {
    const {
      showNavbarOnMount = false,
      showFooterOnMount = false,
    } = this.props;

    this.props.setNavbarVisibility({isVisible: showNavbarOnMount});
    this.props.setFooterVisibility({isVisible: showFooterOnMount});
  }

  componentWillUnmount() {
    const {
      showNavbarOnUnmount = true,
      showFooterOnUnmount = true,
    } = this.props;

    this.props.setNavbarVisibility({isVisible: showNavbarOnUnmount});
    this.props.setFooterVisibility({isVisible: showFooterOnUnmount});
  }

  render() {
    const { innerClass = '' } = this.props;

    return (
      <div className={cx('vh-100 flex justify-center')}>
        <MgTextLogoBouncer className={innerClass} />
      </div>
    );
  }
}

const styles = {
  root: { },
};


export default compose(
  connect(null, mapDispatchToProps),
  injectSheet(styles),
)(InitialLoading);



// WEBPACK FOOTER //
// ./src/pages/_system/InitialLoading.js